import {
  Component,
  OnInit,
  Renderer2,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LanguageServiceService } from './services/language-service.service';
import { DeviceDetectorService } from './services/device-detector.service';
import { NetworkService } from './services/network';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {

  title = 'Zazu';
  isMobile: boolean = false;
  welcome: boolean = false;
  isAr: boolean = false;

  deferredPrompt: any;
  showInstallButton = false;

  showPopup: boolean = false;
  showInstallPopup = false;

  private arabicStyleId = 'arabic-style';

  constructor(
    private _languageService: LanguageServiceService,
    private deviceService: DeviceDetectorService,
    private renderer: Renderer2,
    private network: NetworkService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });

    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = this.deviceService.isMobileDevice();

      this.welcome = localStorage.getItem('welcome') === 'true';
      this.isAr = localStorage.getItem('language') === 'ar';

      this.checkSession();

      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.deferredPrompt = event;
        this.showInstallButton = true;

        if (this.isMobile) {
          this.openInstallPopup();
        }
      });
    }

    this._languageService.currentDirection$.subscribe((direction) => {
      this.document.documentElement.dir = direction;

      if (direction === 'rtl') {
        this.addArabicStylesheet();
      } else {
        this.removeArabicStylesheet();
      }
    });
  }

  openInstallPopup() {
    this.showInstallPopup = true;
    document.body.classList.add('bodyOverFlow');
  }

  closeInstallPopup() {
    this.showInstallPopup = false;
    document.body.classList.remove('bodyOverFlow');
  }

  installPWA() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();

      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        this.deferredPrompt = null;
        this.showInstallButton = false;
        this.closeInstallPopup();
      });
    } else {
      this.closeInstallPopup();
    }
  }

  changeLanguage(language: string) {
    this._languageService.changeLanguage(language);
  }

  openPopup() {
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }

  setCookie(c_name: string, value: string, exdays: number | null) {
    if (!isPlatformBrowser(this.platformId)) return;

    const exdate = new Date();
    if (exdays !== null) {
      exdate.setDate(exdate.getDate() + exdays);
    }

    const c_value =
      encodeURIComponent(value) +
      (exdays === null ? '' : '; expires=' + exdate.toUTCString());

    document.cookie = c_name + '=' + c_value + '; path=/';
  }

  getCookie(c_name: string): string {
    if (!isPlatformBrowser(this.platformId)) return '';

    const name = c_name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length);
      }
    }
    return '';
  }

  checkSession() {
    if (!isPlatformBrowser(this.platformId)) return;

    const c = this.getCookie('visited');
    if (c !== 'yes') {
      this.showPopup = true;
      this.setCookie('visited', 'yes', null);
    }
  }

  private addArabicStylesheet(): void {
    if (!this.document.getElementById(this.arabicStyleId)) {
      const linkEl = this.renderer.createElement('link');
      linkEl.id = this.arabicStyleId;
      linkEl.rel = 'stylesheet';
      linkEl.href = '/assets/styles-ar.css';
      this.renderer.appendChild(this.document.head, linkEl);
    }
  }

  private removeArabicStylesheet(): void {
    const existingLink = this.document.getElementById(this.arabicStyleId);
    if (existingLink) {
      this.renderer.removeChild(this.document.head, existingLink);
    }
  }
}
